"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDomFactories = _interopRequireDefault(require("react-dom-factories"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _CwImage = _interopRequireDefault(require("./CwImage.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _BrowserUserAgent = _interopRequireDefault(require("../../utils/BrowserUserAgent"));

var _ChangeCheck = _interopRequireDefault(require("../../utils/ChangeCheck"));

var CwImage =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwImage, _React$Component);

  function CwImage() {
    (0, _classCallCheck2.default)(this, CwImage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwImage).apply(this, arguments));
  }

  (0, _createClass2.default)(CwImage, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var propsToCheck = ['src', 'alt', 'isInlineSVG', 'className'];
      return (0, _ChangeCheck.default)(propsToCheck, this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var is_chrome = _BrowserUserAgent.default.is_chrome();

      var is_safari = _BrowserUserAgent.default.is_safari();

      if (is_chrome && is_safari) {
        is_safari = false;
      }

      var imageClass = (0, _classnames.default)(this.props.className, (0, _defineProperty2.default)({}, _CwImage.default.cursor, this.props.onClick));

      if (this.props.isInlineSVG) {
        return _react.default.createElement("div", {
          "data-cwid": this.props.cwId,
          onClick: this.props.onClick,
          onFocus: this.props.onFocus,
          onMouseLeave: this.props.onMouseLeave,
          onMouseEnter: this.props.onMouseEnter,
          onBlur: this.props.onBlur
        }, _react.default.createElement(_reactInlinesvg.default, {
          className: imageClass,
          style: this.props.style,
          wrapper: _reactDomFactories.default.div,
          key: this.props.src,
          src: this.props.src,
          cacheGetRequests: true
        }));
      }

      if (is_safari) {
        return _react.default.createElement("div", {
          "data-cwid": this.props.cwId,
          onFocus: this.props.onFocus,
          onMouseLeave: this.props.onMouseLeave,
          onMouseEnter: this.props.onMouseEnter,
          onBlur: this.props.onBlur
        }, _react.default.createElement("img", {
          className: imageClass,
          style: this.props.style,
          src: this.props.src,
          alt: this.props.alt,
          onClick: this.props.onClick
        }));
      } else {
        return _react.default.createElement("img", {
          "data-cwid": this.props.cwId,
          className: imageClass,
          onMouseLeave: this.props.onMouseLeave,
          onMouseEnter: this.props.onMouseEnter,
          style: this.props.style,
          src: this.props.src,
          alt: this.props.alt,
          onClick: this.props.onClick,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur
        });
      }
    }
  }]);
  return CwImage;
}(_react.default.Component);

CwImage.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Path to image
   */
  src: _propTypes.default.string.isRequired,

  /**
   * Callback fired when image is clicked
   */
  onClick: _propTypes.default.func,

  /**
   * Alt text used for screen readers
   */
  alt: _propTypes.default.string,

  /**
   * Controls whether svg or img tag is rendered
   */
  isInlineSVG: _propTypes.default.bool,

  /**
   * Used to add custom css
   */
  className: _propTypes.default.string,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * On Mouse Leave Synthetic event callback
   */
  onMouseLeave: _propTypes.default.func,

  /**
  * On Mouse Enter Synthetic event callback
  */
  onMouseEnter: _propTypes.default.func
};
CwImage.defaultProps = {
  isInlineSVG: true,
  onMouseLeave: function onMouseLeave() {},
  onMouseEnter: function onMouseEnter() {}
};
var _default = CwImage;
exports.default = _default;